module.exports = __webpack_public_path__ + "img/cloud.8e924a82.svg";